import React, { useRef, useState } from 'react';
import MyButton from '../../../components/MyButton';
import AddPhotosIcon from '../../../assets/formIcons/addPhotos.svg';
import DeletePhotoIcon from '../../../assets/formIcons/deletePhoto.svg';
import { PHOTOS_COUNT } from '../../../helpers/constants';
import useInputState from '../../../helpers/hooks/useInputState';
import SearchInput from '../../../components/SearchInput';
import CloseSmallIcon from '../../../assets/formIcons/closeSmall.svg';
import TemplatePhotoPreview from './TemplatePhotoPreview';

function SelectTemplatePhotos({
  setValue, setTempComponentState, initValue = [],
}) {
  const [selected, setSelected] = useState(initValue);
  const [inputVal, setInputVal] = useInputState();

  const handleInputKeyDown = (ev) => {
    if (['Tab', 'Enter', 'Space'].includes(ev.code)) {
      addNewTag(inputVal);
      setInputVal('', true);
    }
  };

  const addNewTag = (tag) => {
    if (!tag || !tag.trim().length || selected.includes(tag)) return;
    setSelected((prev) => [tag.trim(), ...prev]);
  };

  const onTagClick = (tag) => () => {
    setSelected((prev) => prev.filter((el) => el !== tag));
  };

  const handleSubmit = () => {
    setValue(selected);
    setTempComponentState(null);
  };

  return (
    <div className="temp_container">
      <p className="temp_container_title">Шаблонные фото на главной карусели</p>
      <div className="temp_container_scroll with_button">
        <SearchInput
          withLeftIcon={false}
          value={inputVal}
          onChange={setInputVal}
          onKeyDown={handleInputKeyDown}
          labelText="Enter, Tab, Space"
          placeholder="Вставьте id фото"
        />
        <div className="temp_container_tags_wrapper">
          {selected.map((item) => (
            <div
              key={item}
              className="tag_wrapper tag_wrapper_template_photo"
              onClick={onTagClick(item)}
            >
              <TemplatePhotoPreview templateId={item} />
              <img src={CloseSmallIcon} alt="X" className="tag_wrapper_img" />
            </div>
          ))}
        </div>
      </div>

      <MyButton onClick={handleSubmit} text="Ок" className="temp_container_button" />
    </div>
  );
}

export default SelectTemplatePhotos;
